import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import shopinn from "../../Assets/Projects/shopinn.png";
import ecom from "../../Assets/Projects/ecom.png";
import smtadd from "../../Assets/Projects/smtadd.png";
import nivaran from "../../Assets/Projects/nivaran.png";
import customate from "../../Assets/Projects/customate.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={customate}
              isBlog={false}
              title="Customate"
              description="Customate is an innovative web application designed to streamline the process of selecting and customizing products online. Built using ReactJS, Redux, JavaScript, and AWS, Customate offers a user-friendly interface that allows users to easily choose and personalize items according to their preferences."
              demoLink="https://shop.customate.in/"
              ghLink="https://github.com/arnav2000agr"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nivaran}
              isBlog={false}
              title="Nivaran"
              description="Nivaran is an advanced web application designed to revolutionize the grievance filing, tracking, and resolution processes. Utilizing the MERN stack (MongoDB, Express.js, React.js, and Node.js) and leveraging AWS and Nginx for enhanced scalability and security, Nivaran aims to provide a comprehensive solution for managing grievances efficiently"
              ghLink="https://github.com/arnav2000agr/Nivaran_Frontend/tree/arnav"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={smtadd}
              isBlog={false}
              title="Smart Attendance System"
              description="The Smart Attendance System is an advanced solution designed to modernize and streamline attendance management using cutting-edge facial recognition technology. Built on the ArcFace model, the system focuses on enhancing efficiency, convenience, security, and accuracy in tracking attendance."
              ghLink="https://github.com/arnav2000agr"            
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shopinn}
              isBlog={false}
              title="ShopInn"
              description="ShopInn is a dynamic eCommerce platform designed to provide a seamless and enjoyable online shopping experience. With its intuitive interface and robust feature set, ShopInn caters to a wide range of users, offering a diverse selection of products and an effortless shopping journey."
              ghLink="https://github.com/arnav2000agr"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecom}
              isBlog={false}
              title="Movie+"
              description="Movie+ is a premier streaming platform offering a rich variety of family-friendly entertainment and beloved classics. With an extensive library of movies, TV shows, and exclusive original content, Movie+ provides a delightful viewing experience for audiences of all ages."
              ghLink="https://github.com/arnav2000agr"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
